import { Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguageService } from '../../../core/services/language.service';
import { DialogService } from '../../../osp-ui/services/dialog.service';
import { NotificationFormDialogComponent } from '../components/notification-form/notification-form.component';
import { ViewAlarmRule } from '../contract/view-alarm-rule.contract';
import { AlarmTypeResolverPipe } from '../pipes/alarm-type-resolver.pipe';

@Injectable({
  providedIn: 'root',
})
export class NotificationFormDialogService {
  private readonly ADD_EDIT_DIALOG_WIDTH = '1225px';
  private readonly ADD_EDIT_DIALOG_HEIGHT = '800px';

  private dialogRef?: DynamicDialogRef;

  constructor(
    private languageService: LanguageService,
    private dialogService: DialogService,
    private alarmTypeResolver: AlarmTypeResolverPipe,
  ) {}

  public openDialog(data?: ViewAlarmRule): void {
    this.dialogRef = this.dialogService.open(NotificationFormDialogComponent, {
      data,
      header: this.resolveHeaderText(data),
      width: this.ADD_EDIT_DIALOG_WIDTH,
      height: this.ADD_EDIT_DIALOG_HEIGHT,
    });
  }

  private resolveHeaderText(data?: ViewAlarmRule): string {
    if (!data) {
      return this.translate('modules.notification.alarmRuleAddEdit.add');
    }
    return this.translate('revolution.modules.notification.alarmRuleAddEdit.edit', {
      value: this.alarmTypeResolver.transform(data.alarmType),
    });
  }

  private translate(key: string, interpolateParams?: object): string {
    return this.languageService.getInstant(key, interpolateParams);
  }
}
